import { TutorialPanelProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';

export class Tour implements TutorialPanelProps.Tutorial {
    name: string;
    title: string;
    description: string;
    tasks: TutorialPanelProps.Task[];

    completed: boolean;
    completedScreenDescription: string;

    /**
     * Construct a Tour object from the minimum required information(name and content) to define a tour.
     * @param name a unique identifier used to identify tours for metrics purposes
     * @param title the localized title of the tour
     * @param description the localized description of the tour
     * @param tasks the tasks of the tour
     */
    constructor(name: string, title: string, description: string, tasks: TutorialPanelProps.Task[]) {
        this.name = name;
        this.title = title;
        this.description = description;
        this.tasks = tasks;
        this.completedScreenDescription = constants.COMPLETED_SCREEN_DESCRIPTION;
        this.completed = false;
    }
}
